/*
|--------------------------------------------------------------------------
| Custom Javascript code
|--------------------------------------------------------------------------
|
| Now that you configured your website, you can write additional Javascript
| code inside the following function. You might want to add more plugins and
| initialize them in this file.
|
*/
$(document).ready(function() {
    $('[data-group="continental"]').click();
});

$(function () {




    //MENU
    $(document).on("click", ".menu-btn", function (e) {
        e.preventDefault();
        $('.menu-btn').toggleClass("active");
        $('.menu-mobile').toggleClass("active");
    });

    jarallax(document.querySelectorAll('.jarallax'), {
        onScroll: function (calculations) {
            console.log(calculations);
        }
    });


    $('.contactForm').submit(function (e) {
        // Prevent the form from actually submitting
        e.preventDefault();

        console.log("test");

        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: $(this).serialize(),
            cache: false,
            beforeSend: function () {
                console.log("loading");
                $('.contactForm .btn-submit').html("<span class='preloader'></span>loading");
            }
        }).done(function (data) {
            //success...
            if (data.success) {
                // remove loading and show success message
                var tempcontent = "<h4 class='alert-heading'>Thank you very much!</h4><p>We usually reply within 24 hours.</p>";
                $(".response").show();
                $(".response").html(tempcontent);
                $('.contactForm').hide();
            }
            // errors...
            else {
                if (data.errors) {
                    $('.response').addClass('alert-danger').removeClass('alert-success');
                    $(".response").show();
                    $.each(data.errors, function (field, msgs) {
                        var tempcontent = field + " : " + msgs.toString();
                        $(".response").append(tempcontent + "<br>");
                    });


                    $('.contactForm .btn-submit').html("Submit");
                }
            }
        });
    });


    $('.jobApplication').submit(function (e) {
        // Prevent the form from actually submitting
        e.preventDefault();

        console.log("test");

        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: $(this).serialize(),
            cache: false,
            beforeSend: function () {
                console.log("loading");
                $('.jobApplication .btn-submit').html("<span class='preloader'></span>loading");
            }
        }).done(function (data) {
            //success...
            if (data.success) {
                // remove loading and show success message
                var tempcontent = "<h4 class='alert-heading'>Thank you very much!</h4><p>We will review your application as soon as possible.</p>";
                $(".response").show();
                $(".response").html(tempcontent);
                $('.jobApplication').hide();
            }
            // errors...
            else {
                if (data.errors) {
                    $('.response').addClass('alert-danger').removeClass('alert-success');
                    $(".response").show();
                    $.each(data.errors, function (field, msgs) {
                        var tempcontent = field + " : " + msgs.toString();
                        $(".response").append(tempcontent + "<br>");
                    });


                    $('.jobApplication .btn-submit').html("Submit");
                }
            }
        });
    });
    //Footer subscribe
    $('.subscribeToMailingList').submit(function (e) {
        // Prevent the form from actually submitting
        e.preventDefault();

        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: $(this).serialize(),
            cache: false,
            beforeSend: function () {
                console.log("loading");
                $('.subscribeToMailingList .btn-submit').html("<span class='preloader'></span>loading");
            }
        }).done(function (data) {
            //success...
            if (data.success) {
                // remove loading and show success message
                var tempcontent = "<h4 class='alert-heading'>Thank you!</h4><p>We will send you newsletter with our best products.</p>";
                $(".footer-response").show();
                $(".footer-response").html(tempcontent);
                $('.subscribeToMailingList').hide();
                tempcontent = "<h4 class='alert-heading m-0'>Thank you!</h4><p class='m-0'>We will send you newsletter with our best products.</p>";
                $(".header-response").show();
                $(".header-response").html(tempcontent);
                $('.subscribeToMailingList-header').hide();
            }
            // errors...
            else {
                if (data.errors) {
                    $('.footer-response').addClass('alert-danger').removeClass('alert-success');
                    $("footer-response").show();
                    $.each(data.errors, function (field, msgs) {
                        var tempcontent = field + " : " + msgs.toString();
                        $("footer-response").append(tempcontent + "<br>");
                    });

                    $('.subscribeToMailingList .btn-submit').html("Submit");
                }
            }
        });
    });

    //Header subscribe
    $('.subscribeToMailingList-header').submit(function (e) {
        // Prevent the form from actually submitting
        e.preventDefault();

        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: $(this).serialize(),
            cache: false,
            beforeSend: function () {
                console.log("loading");
                $('.subscribeToMailingList-header .btn-submit').html("<span class='preloader'></span>loading");
            }
        }).done(function (data) {
            //success...
            if (data.success) {
                // remove loading and show success message
                var tempcontent = "<h4 class='alert-heading m-0'>Thank you!</h4><p class='m-0'>We will send you newsletter with our best products.</p>";
                $(".header-response").show();
                $(".header-response").html(tempcontent);
                $('.subscribeToMailingList-header').hide();
                tempcontent = "<h4 class='alert-heading'>Thank you!</h4><p>We will send you newsletter with our best products.</p>";
                $(".footer-response").show();
                $(".footer-response").html(tempcontent);
                $('.subscribeToMailingList').hide();
            }
            // errors...
            else {
                if (data.errors) {
                    $('.header-response').addClass('alert-danger').removeClass('alert-success');
                    $("header-response").show();
                    $.each(data.errors, function (field, msgs) {
                        var tempcontent = field + " : " + msgs.toString();
                        $("header-response").append(tempcontent + "<br>");
                    });

                    $('.subscribeToMailingList .btn-submit').html("Submit");
                }
            }
        });
    });








    $('.selectpicker').selectpicker({
        style: 'btn-info',
        size: 4
    });

    bs_input_file();

    function bs_input_file() {
        $(".input-file").before(
            function () {
                if (!$(this).prev().hasClass('input-ghost')) {
                    var element = $("<input type='file' class='input-ghost' style='display:none;visibility:hidden; height:0'>");
                    element.attr("name", $(this).attr("name"));
                    element.change(function () {
                        element.next(element).find('input').val((element.val()).split('\\').pop());
                    });
                    $(this).find("button.btn-choose").click(function () {
                        element.click();
                    });
                    $(this).find("button.btn-reset").click(function () {
                        element.val(null);
                        $(this).parents(".input-file").find('input').val('');
                    });
                    $(this).find('input').css("cursor", "pointer");
                    $(this).find('input').mousedown(function () {
                        $(this).parents('.input-file').prev().click();
                        return false;
                    });
                    return element;
                }
            }
        );
    }


});



//////////////////
// WEBPACK FOOTER
// ./src/assets/js/src/script.js
// module id = 83
// module chunks = 0